import { TextAreaResizable } from "@/Common/Components/Inputs/TextAreaResizable";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { BaseWorkSafeBcSubSection, IBaseWorkSafeBcSubSectionProps } from "../BaseWorkSafeBcSubSection";
import { WorkSafeBcFormValidator } from "../Models/WorkSafeBcFormValidator";

class WorkSafeBcClinicalInformationSection extends BaseWorkSafeBcSubSection<IBaseWorkSafeBcSubSectionProps, never> {
    public render(): JSX.Element {
        const data = this.props.model;
        const validator = new WorkSafeBcFormValidator(data);

        return (
            <div className="flex-grow-container subsection-border-top">
                <div className="row">
                    <div className="col-md-12">
                        <label className="form-label bold f16px">{this.getString("WorkSafeBc_ClinicalInformationLabel")}</label>
                    </div>
                </div>
                {this.renderFields(
                    {
                        labelValueKey: "WorkSafeBc_ClinicalInformationSubLabel",
                        value: JSXHelper.BreakStringIntoParagraphs(data.ClinicalInformation),
                        required: true
                    },
                    <TextAreaResizable
                        id="WorkSafeBc_ClinicalInformationField"
                        text={data.ClinicalInformation}
                        className="form-control textarea-resize-vertical"
                        onChange={value => this.props.mutateModelState(s => s.ClinicalInformation = value)}
                        rows={7}
                        maxRows={7}
                        maxLength={800}
                        minHeightPx={75}
                        invalid={!validator.isClinicalInformationFieldValid()}
                    />
                )}
            </div>
        );
    }
}

export { WorkSafeBcClinicalInformationSection };
